import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=189ff79f&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Crumbs: require('/var/www/components/crumbs/crumbs.vue').default,Contacts: require('/var/www/components/contacts/contacts.vue').default})
